module.exports = __webpack_public_path__ + "img/1691832017405-image.jpg.509d6333.webp";